export const PRICING_HEADING_CONSTANTS = {
  organization_server: "Dedicated Server for Organization (for 10+ Users)",
  user_server: "Dedicated VM Minimum 10 user(1:1 VM )",
};

export const ORGANIZATION_SERVER = [
  {
    cpu: "2GB",
    memory: "4GB",
    user_disk: "20GB",
    pricing: { linux: "₹1,914", windows: "₹2,610" },
  },
  {
    cpu: "4GB",
    memory: "8GB",
    user_disk: "40GB",
    pricing: { linux: "₹2,610", windows: "₹3,306" },
  },
  {
    cpu: "8GB",
    memory: "16GB",
    user_disk: "100GB",
    pricing: { linux: "₹3,654", windows: "₹4,437" },
  },
  {
    cpu: "2GB",
    memory: "8GB",
    user_disk: "40GB",
    pricing: { linux: "₹2,262", windows: "₹2,958" },
  },
  {
    cpu: "4GB",
    memory: "16GB",
    user_disk: "100GB",
    pricing: { linux: "₹3,132", windows: "₹3,828" },
  },
  {
    cpu: "8GB",
    memory: "32GB",
    user_disk: "100GB",
    pricing: { linux: "₹4,698", windows: "₹5,481" },
  },
];

export const USER_SERVER = [
  {
    cpu: "2GB",
    memory: "4GB",
    user_disk: "20GB",
    pricing: { linux: "₹3,132", windows: "₹3,828" },
  },
  {
    cpu: "4GB",
    memory: "8GB",
    user_disk: "40GB",
    pricing: { linux: "₹5,046", windows: "₹5,655" },
  },
  {
    cpu: "8GB",
    memory: "16GB",
    user_disk: "100GB",
    pricing: { linux: "₹10,440", windows: "₹11,136" },
  },
  {
    cpu: "2GB",
    memory: "8GB",
    user_disk: "40GB",
    pricing: { linux: "₹5,394", windows: "₹6,003" },
  },
  {
    cpu: "4GB",
    memory: "16GB",
    user_disk: "100GB",
    pricing: { linux: "₹9,744", windows: "₹10,353" },
  },
  {
    cpu: "8GB",
    memory: "32GB",
    user_disk: "100GB",
    pricing: { linux: "₹16,269", windows: "₹16,878" },
  },
];
